import {nextTick} from 'vue';
import createVueApp from '../../shared/vue/create-app';
import _u from '../../shared/utils';
import $ from 'jquery';

import '../../components';
// TODO:remove imports??
import '../../components/map/markerclusterer';
import '../../components/map/map-marker';
import {initListingCardComponent} from '../../components/card/listing-card';
import {
    AddressInputMeta,
    CheckboxInputMeta,
    CheckGroupInputMeta,
    DynamicInputMetaFactory,
    MultiselectInputMeta,
    NoInputMeta,
    RangeInputMeta,
    SelectInputMeta,
    TwoSidesRangeInputMeta,
} from '../../components/inputs/custom-inputs-models';

import {allowRenderMap, GoogleMap} from '../../components/map/google-map-models';
import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import deepClone from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import {store} from '../../store/global-store';
import {globalActions} from '../../store/global-actions';
import {BaseMap} from '../../components/map/map-models';
import initCustomControls from '../../components/custom-controls';
import initSearchFilterComponent from '../../components/filter/search-filter';
import initMapMakerComponent from '../../components/map/map-marker';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initFavoriteSwitchComponent from '../../components/favorite-switch';
import {initCurrencyPriceComponents} from '../../components/inputs/currency-price';
import initListingExtraDetailsComponent from '../../components/card/listing-extra-details';
import initListingContactForm from '../../components/listing-contact-form';
import initAutocompleteComponent from '../../components/map/autocomplete';
import initCommentsComponents from '../../components/comments';
import initGaTrackerComponent from '../../components/ga-tracking';
import initSocialsComponent from '../../components/socials/jssocials';
import initListReviewComponents from '../../components/listing-review';
import initPriceHistoryChartComponent from '../../components/price-history-chart';
import initListingStatisticsComponent from '../../components/listing-statistics';
import initStarRatingComponent from '../../components/star-rating';
import initMortgageCalculator from '../../components/mortgage-calculator';
import initMarkdownViewerComponent from '../../components/markdown/markdown-viewer';
import initOpenHoursComponent from '../../components/open-hours';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import VueMultiselectExtended from '../../components/inputs/multiselect';
import initAdvertPreviewComponent from '../../components/advert-preview';
import {initGAComponents} from '../../components';
import initCreateOneClickInquiry from '../../components/create-one-click-inquiry';

const initSearchPage = (settings) => {
    $(document).ready(() => {
        const app = createVueApp({
            store,
            mixins: [openPreviewMixin],
            components: {
                Multiselect: VueMultiselectExtended,
            },
            data() {
                this.initFilter(settings.searchResult.filter);
                const isSmallScreen = window.matchMedia('(max-width: 560px)').matches;

                return Object.assign({
                    map: null,
                    redrawNeeded: 0,
                    mapView: false,
                    markerCluster: null,
                    _markerCache: null,
                    needUpdateMarkerCluster: false,
                    mapMinZoom: settings.mapSettings.minZoom,
                    mapMaxZoom: settings.mapSettings.maxZoom,
                    bigCityZoom: settings.mapSettings.bigCityZoom,
                    regionZoom: settings.mapSettings.regionZoom,
                    showListingZoom: settings.mapSettings.addressZoom,
                    currentDataRequest: null,
                    filterTemplate: settings.filterTemplate,
                    sortOptions: settings.sortOptions,
                    needRenderMap: !isSmallScreen && allowRenderMap(settings.headers),
                    isSmallScreen,
                    measurementUnit: settings.measurementUnit,
                    labels: settings.labels,
                    searchResults: settings.searchResult.results,
                    markerSearchResults: settings.searchResult.results.map(this.getMarkerInfo),
                    filterOptions: this.initFilterOptions(settings.searchResult.opts),
                    cityName: this.extractCityNameFromSearchResult(settings.searchResult),
                    opts: settings.searchResult.opts,
                    showUpdatedModal: false,
                    resultsLoading: true,
                    showBoostModal: false,
                    firstLoading: true,
                    showContactButton: settings.matchingItemId != '',
                    previewId: settings.searchResult.filter.previewId,
                    fewResultsCount: settings.fewResultsCount,
                    searchPreviewUrl: '',
                    createOrderUrl: '',
                    isBuyLocationMode: settings.isBuyLocationMode,
                    isMobileDevice: settings.isMobileDevice,
                    titleFromServer: '',
                    isNewDataSearched: false,
                    isPreviewPage: null,
                });
            },
            watch: {
                filter: {
                    handler: debounce(function(newVal) {
                        // eslint-disable-next-line no-invalid-this
                        this.updateUrlFilter(newVal);
                        // eslint-disable-next-line no-invalid-this
                        this.renderMap();
                    },
                    100, {
                        'leading': true,
                        'trailing': false,
                    }),
                    deep: true,
                    immediate: true,
                },
            },
            emits: ['mouseover', 'mouseleave'],
            computed: {
                filter: {
                    get() {
                        return store.getters.filter;
                    },
                    set(val) {
                        store.commit('initFilter', val);
                    },
                },
                defaultSortOption() {
                    return this.sortOptions.find((o) => o.isDefault);
                },
                sortedSearchResults() {
                    if (!this.searchResults.length) {
                        return this.searchResults;
                    }

                    return this.sortItems(this.searchResults);
                },
                selectedSortOption: {
                    get() {
                        return this.sortOptions.find((o) => o.optionId === this.filter.sortOptionId) || this.defaultSortOption;
                    },
                    set(sortOption) {
                        this.updateFilter('sortOptionId', sortOption.optionId);
                    },
                },
                pricePickerMin() {
                    return this.opts.priceOptions[0].value;
                },
                pricePickerMax() {
                    return this.opts.priceOptions[this.opts.priceOptions.length - 1].value ||
                        this.opts.priceOptions[this.opts.priceOptions.length - 2].value;
                },
                isPriceNotFiltered() {
                    return !(this.filter.minPrice || this.filter.maxPrice) ||
                        (!this.filter.minPrice && this.filter.maxPrice === this.pricePickerMax) ||
                        (this.filter.minPrice === this.pricePickerMin && !this.filter.maxPrice) ||
                        (this.filter.minPrice === this.pricePickerMin && this.filter.maxPrice === this.pricePickerMax);
                },
                isMaxPriceSpecified() {
                    return this.filter.maxPrice;
                },
                minPrice() {
                    return !this.filter.minPrice ?
                        settings.labels.zeroPrice :
                        this.opts.priceOptions.find((i) => i.value === this.filter.minPrice).label;
                },
                maxPrice() {
                    return !this.filter.maxPrice ?
                        settings.labels.maxPrice :
                        this.opts.priceOptions.find((i) => i.value === this.filter.maxPrice).label;
                },
                priceRangeLabel() {
                    let res;
                    if (this.isPriceNotFiltered) {
                        res = settings.labels.anyPrice;
                    } else {
                        const min = this.minPrice;
                        const max = this.maxPrice;

                        if (this.filter.minPrice === this.pricePickerMax) {
                            res = `${min} - ${settings.labels.maxPrice}`;
                        } else {
                            res = `${min} - ${max}`;
                        }
                    }
                    return res;
                },
                noItemsFound() {
                    return this.searchResults.length === 0;
                },
                fewResultsFound() {
                    return !this.noItemsFound && this.searchResults.length <= this.fewResultsCount;
                },
                searchText: {
                    get() {
                        return this.filter.text;
                    },
                    set: () => {
                        // to mute vue.js complains
                    },
                },
                previewSrc() {
                    if (this.previewId) {
                        return `${settings.urls.previewUrl}/${this.previewId}`;
                    }
                    return null;
                },

                previewState() {
                    // NOTE: new previewState object is created every time new preview is opened
                    // 'previewState' is used as temporary initial data object for preview component
                    // (rendered inside async - component based on previewScr)
                    if (this.previewId) {
                        return {
                            isCompactActionsMode: false,
                            currentPage: location.pathname + location.search + location.hash,
                            switchCompactActionsMode(val) {
                                this.isCompactActionsMode = val;
                            },
                            shouldReplaceHistory: false,
                        };
                    }

                    return null;
                },

                hasPreviewNext() {
                    if (this.previewId && this.searchResults.length > 1) {
                        const index = this.getPreviewListingIndex();
                        return index >= 0 && this.searchResults.length > index + 1;
                    }

                    return false;
                },

                hasPreviewPrev() {
                    if (this.previewId && this.searchResults.length > 1) {
                        const index = this.getPreviewListingIndex();
                        return index > 0 && this.searchResults.length > index - 1;
                    }

                    return false;
                },

                showFilteredViews() {
                    return this.needFilterViews && this.filteredViewsData;
                },

                formattedCityName() {
                    return _u.changeWordForm(this.cityName);
                },

                previewPayload() {
                    return {
                        listingId: this.previewId,
                        listingType: this.opts.listingType,
                        previewUrl: this.searchPreviewUrl,
                    };
                },
            },
            updated() {
                if (this.needUpdateMarkerCluster) {
                    nextTick(() => {
                        this.updateMarkerClusters();
                        this.scrollToTop();
                    });
                }
            },
            methods: {
                initFilter() {
                    store.commit('initFilter', settings.searchResult.filter);
                    store.subscribeAction((action) => {
                        if (action.type === 'applyFilter') {
                            this.applyFilter();
                        }
                    });
                },
                updateFilter(key, value) {
                    store.commit('updateFilter', {key, value});
                },

                updateUrlFilter(filterNewVal) {
                    if (!this.isUrlFilterChecked) {
                        this.subscribeUrlHashChange();

                        const filterFromUrl = _u.getHashLocationObject(this.filterTemplate);

                        if (filterFromUrl) {
                            this.filter = filterFromUrl;
                        }

                        if (this.previewId) { // do not load map until first preview is closed
                            this.needRenderMap = false;
                        }

                        if (!this.needRenderMap) {
                            this.applyFilter();
                        }

                        this.isUrlFilterChecked = true;
                    } else {
                        if (window.location.hash.startsWith('#comment')) {
                            window.location = window.location.hash;
                        }

                        _u.updateHashLocation(filterNewVal);
                    }
                },

                updatePageTitle() {
                    if (settings.titleTemplate && this.titleAddress) {
                        document.title = this.isNewDataSearched || this.isPreviewPage ?
                            _u.formatString(settings.titleTemplate, this.titleAddress) : this.titleFromServer;
                    }
                },

                initPageTitle() {
                    this.titleFromServer = document.title;
                    this.titleAddress = this._extractTitleAddressFromGeoData(settings.searchResult.locationGeoData);
                },
                _getDifference(object, base) {
                    function changes(object, base) {
                        return transform(object,
                            function(result, value, key) {
                                if (!isEqual(value, base[key])) {
                                    result[key] =
                                        (isObject(value) && isObject(base[key])) ?
                                            changes(value, base[key]) :
                                            value;
                                }
                            });
                    }

                    return changes(object, base);
                },

                subscribeUrlHashChange() {
                    window.addEventListener('popstate',
                        debounce(() => {
                            const filterFromUrl = _u.getHashLocationObject(this.filterTemplate);

                            if (filterFromUrl) {
                                if (this.filter.uid !== filterFromUrl.uid) {
                                    this.filter = filterFromUrl;
                                    this.resetMapCenter();
                                }
                            } else {
                                if (!window.location.hash.startsWith('#comment')) {
                                    const id = this.checkPreviewUrl(document.location.href);
                                    if (id) {
                                        const radix = 10;
                                        this.preview(parseInt(id, radix));
                                    } else {
                                        document.location.reload();
                                    }
                                }
                            }
                        },
                        100));
                },

                renderMap() {
                    if (!this.map && this.needRenderMap) {
                        nextTick(() => {
                            this.map = new GoogleMap(document.getElementById('map'), {
                                center: {
                                    lat: this.filter.lat,
                                    lng: this.filter.lon,
                                },
                                zoom: this.filter.zoom,
                                minZoom: this.mapMinZoom,
                                maxZoom: this.mapMaxZoom,
                                zoomControlOptions: {
                                    position: google.maps.ControlPosition.RIGHT_CENTER,
                                },
                            }, settings.headers);

                            this.map.addListener('idle',
                                () => {
                                    this.applyFilter();
                                    this.clearMapIdleListener();
                                    this.addMapIdleListener();
                                });

                            this.map.addListener('zoom_changed', () => {
                                this.updateFilter('zoom', this.map.getZoom());
                            });
                        });

                        return true;
                    }

                    return false;
                },

                addMapIdleListener() {
                    if (this.map) {
                        this.map.addListener('idle', this.applyFilter);
                    }
                },

                clearMapIdleListener() {
                    if (this.map) {
                        this.map.clearListeners('idle');
                    }
                },

                applyFilter() {
                    if (!this._applyFilter) {
                        this._applyFilter = debounce(this.requestDataUpdate, this.opts.debounceTime);
                    }

                    this._applyFilter();
                },

                requestDataUpdate() {
                    this.updateFilterLocation();

                    let param = Object.assign({}, this.filter);

                    param = JSON.stringify(param);
                    this.sendSearchRequest(settings.urls.dataRequestUrl, param, this.updateItems);
                },

                updateFilterLocation() {
                    if (this.needRenderMap) {
                        const center = this.map.getCenter();
                        if (center != null && (this.filter.lat !== center.lat() || this.filter.lon !== center.lng())) {
                            this.updateFilter('lat', center.lat());
                            this.updateFilter('lon', center.lng());
                        }

                        this.updateFilter('bounds', this.map.getBoundsArray());
                    }
                },

                resetMapCenter() {
                    if (this.needRenderMap) {
                        const center = this.map.getCenter();
                        if (center != null && (this.filter.lat !== center.lat() || this.filter.lon !== center.lng())) {
                            this.map.setCenter({lat: this.filter.lat, lng: this.filter.lon});
                        }
                    }
                },

                sendSearchRequest(url, requestData, callback) {
                    this.currentDataRequest = $.ajax({
                        type: 'POST',
                        url,
                        contentType: 'application/json',
                        data: requestData,
                        context: this,
                        beforeSend() {
                            if (this.currentDataRequest != null) {
                                this.currentDataRequest.abort();
                            }
                            setTimeout(() => {
                                if (this.currentDataRequest) {
                                    this.resultsLoading = true;
                                }
                            }, 500);
                        },
                        complete() {
                            this.currentDataRequest = null;
                            this.resultsLoading = false;
                            this.firstLoading = false;
                        },
                    })
                        .done(callback);
                },

                filterUpdated(kayValue) {
                    this.updateFilter(kayValue.key, kayValue.val);
                    this.applyFilter();
                },

                moreOptionSelected() {
                    this.applyFilter();
                },

                scrollToTop() {
                    const scrollContainer = document.getElementById('search-results-container');

                    if (scrollContainer) {
                        scrollContainer.scrollTop = 0;
                    }
                },

                updateItems(newerItems) {
                    this.clearMarkerCache();
                    this.markerSearchResults = newerItems.map(this.getMarkerInfo);
                    this.searchResults = newerItems;

                    nextTick(() => {
                        nextTick(() => {
                            this.redrawNeeded++;
                            this.needUpdateMarkerCluster = true;
                            this.tryShowOnMap();
                        });
                    });
                },

                repositionMap() {
                    if (!this.needRenderMap) {
                        this.applyFilter();
                    }

                    if (this.map) {
                        this.map.setCenter({lat: this.filter.lat, lng: this.filter.lon});
                        this.fitMapToBounds(this.filter.bounds);
                    }
                },

                fitMapToBounds(boundsArray) {
                    if (boundsArray && boundsArray.length) {
                        const viewPort = this.map.getViewPort(boundsArray);
                        this.map.fitBounds(viewPort);

                        this.zoomInMapIfTooSmall();
                    }
                },

                zoomInMapIfTooSmall(zoom) {
                    zoom = zoom ? zoom : this.regionZoom;

                    if (this.needRenderMap && this.map && this.map.getZoom() < zoom) {
                        this.map.setZoom(zoom);
                    }

                    if (!this.needRenderMap) {
                        this.updateFilter('zoom', zoom);
                    }
                },

                zoomOutMapIfTooBig(zoom) {
                    zoom = zoom ? zoom : this.regionZoom;

                    if (this.needRenderMap && this.map.getZoom() > zoom) {
                        this.map.setZoom(zoom);
                    }

                    if (!this.needRenderMap) {
                        this.updateFilter('zoom', zoom);
                    }
                },

                preview(listingId) {
                    this.previewId = listingId;

                    this.isPreviewPage = this.isPreviewPage ?? false;
                    const index = this.getPreviewListingIndex();
                    if (this.hasListingInSearchResults(index)) {
                        this.searchPreviewUrl = this.getListingPreviewUrlByIndex(index);
                    }
                },

                hasListingInSearchResults(index) {
                    return index >= 0;
                },

                getListingPreviewUrlByIndex(index) {
                    const listing = this.searchResults[index];
                    return listing?.previewUrl;
                },

                closePreview(event) {
                    this.isPreviewPage = this.isPreviewPage ?? true;
                    this.updatePageTitle();

                    if (this.previewId) {
                        this.previewId = null;

                        this.resetPageUrl(event);
                    }

                    if (!this.needRenderMap && !this.isSmallScreen) {
                        this.needRenderMap = true; // render map after first preview is closed on desktop
                        this.renderMap();
                    }

                    if (this.isMobileDevice) {
                        globalActions.showFeedbackButton();
                    }
                },

                resetPageUrl(closeEvent) {
                    if (closeEvent && closeEvent.closeOnBack) {
                        return;
                    }

                    const searchPageUrl = this.getSearchPageUrl(this.opts.listingSearchType, this.filter);
                    if (this.getCurrentLocation() !== searchPageUrl && searchPageUrl) {
                        window.history.pushState({}, document.title, searchPageUrl);
                    }

                    _u.updateHashLocation(this.filter);
                },

                previewNext() {
                    if (this.hasPreviewNext) {
                        const index = this.getPreviewListingIndex() + 1;
                        const listing = this.searchResults[index];
                        this.searchPreviewUrl = listing?.previewUrl;
                        this.preview(listing.id);

                        globalActions.markAsViewed(listing.id);
                    }
                },

                previewPrev() {
                    if (this.hasPreviewPrev) {
                        const index = this.getPreviewListingIndex() - 1;
                        const listing = this.searchResults[index];
                        this.searchPreviewUrl = listing?.previewUrl;
                        this.preview(listing.id);

                        globalActions.markAsViewed(listing.id);
                    }
                },

                getCurrentLocation() {
                    return location.pathname + location.search + location.hash;
                },

                getPreviewListingIndex() {
                    return this.searchResults.findIndex((l) => l.id === this.previewId);
                },

                getPreviewListing() {
                    return this.searchResults.find((l) => l.id === this.previewId);
                },

                toggleFavoriteUrl(listing) {
                    if (this.isOwner(listing)) {
                        return null;
                    }

                    return `${settings.urls.toggleFavoriteUrl}/${listing.id}`;
                },

                loadPhoneUrl(listing) {
                    return this.buildListingUrl(settings.urls.loadPhoneUrl, listing);
                },

                buildListingUrl(url, listing) {
                    return url.replace(0, listing.id);
                },

                checkPreviewUrl(url) {
                    const previewPattern = new RegExp(`(\\${settings.urls.detailsUrl}\\/\\d+)$`);
                    const matches = url.match(previewPattern);
                    return matches && matches.length > 0 ? matches[0].split('/')[2] : null;
                },

                priceAvailable(listing) {
                    return !listing.hidePrice;
                },

                askForPriceAvailable(listing) {
                    return listing && !this.isOwner(listing) && listing.status === settings.listedPropertyStatus;
                },

                isOwner(listing) {
                    return listing.userId === settings.currentUserId;
                },

                toggleSearchView() {
                    this.needRenderMap = true;
                    this.mapView = !this.mapView;

                    this.mapView ? this.addMapIdleListener() : this.clearMapIdleListener();
                    this.renderMap();
                    nextTick(() => this.setInitialMapBounds());
                },

                hoverListing(listing) {
                    listing['mouseOver'] = true;
                },

                overListingHover(listing) {
                    listing['mouseOver'] = false;
                },

                changeListingType(listingType) {
                    const filterParam = Object.assign({}, this.filter);

                    filterParam.sortOptionId = this.defaultSortOption.optionId;
                    filterParam.matchingItemId = null;
                    filterParam.bounds = this.getCurrentBounds();
                    filterParam.maxPrice = null;
                    filterParam.minPrice = null;
                    filterParam.offerType = listingType % 2; // TODO: pass offer type in nice way

                    const searchPageUrl = this.getSearchPageUrl(listingType, filterParam);
                    window.location.href = `${searchPageUrl}#${JSON.stringify(filterParam)}`;
                },

                getSearchPageUrl(listingType, filter) {
                    const locParamName = settings.searchUrlsParams[0];
                    const latParamName = settings.searchUrlsParams[1];
                    const lonParamName = settings.searchUrlsParams[2];

                    return `${settings.searchUrls[listingType]}?${locParamName}=${filter.text}&${latParamName}=${filter.lat}&${lonParamName}=${filter.lon}`;
                },

                sortItems(items) {
                    const that = this;

                    items.sort(function(a, b) {
                        let sortOption = that.selectedSortOption;

                        if (a[sortOption.field] === null && b[sortOption.field] === null) {
                            sortOption = that.defaultSortOption;
                        }
                        const aValue = a[sortOption.field] === null ? -1 : a[sortOption.field];
                        const bValue = b[sortOption.field] === null ? -1 : b[sortOption.field];

                        const result = sortOption.isDate ?
                            Date.parse(aValue) - Date.parse(bValue) :
                            aValue - bValue;

                        return sortOption.isAscending || sortOption.isDefault ? result : -1 * result;
                    });

                    return items;
                },

                saveInquiry() {
                    this.updateFilter('bounds', this.getCurrentBounds());
                    const param = Object.assign({}, this.filter);

                    this.sendPostRequest(settings.urls.saveInquiryUrl, param)
                        .done((result) => {
                            if (!result.error) {
                                window.location.href = result.redirectUrl;
                            } else {
                                globalActions.openInfoModal(settings.labels.filterNotSaved, result.error);
                            }
                        });
                },

                redirectPropertyCreation() {
                    window.location.href = settings.urls.propertyCreateUrl;
                },

                updateMarkerClusters() {
                    const markers = this.getRenderedMarkers();

                    if (this.markerCluster && markers.length === 0) {
                        this.markerCluster.clearMarkers();

                        if (this.markerSearchResults.length === 0) {
                            this.needUpdateMarkerCluster = false;
                        }

                        return;
                    }

                    if (markers.length) {
                        this.needUpdateMarkerCluster = false;

                        if (this.markerCluster) {
                            this.markerCluster.clearMarkers();
                            this.markerCluster.addMarkers(markers);
                        } else if (this.map && !(this.map.getInternalMap() instanceof BaseMap)) {
                            this.markerCluster = new MarkerClusterer(this.map.getInternalMap(),
                                markers, {
                                    zoomOnClick: true,
                                    gridSize: 20, // default is 60, set bigger to make clusters bigger
                                    styles: this.getClustersStyles(),
                                    maxZoom: this.mapMaxZoom - 1,
                                });
                        }
                    }
                },

                getRenderedMarkers() {
                    return this.$refs.markerItems ? this.$refs.markerItems.map((i) => i.marker).filter((i) => i != null) : [];
                },

                getListing(listingId) {
                    return this.searchResults.find((l) => l.id === listingId);
                },

                getMarkerCache() {
                    if (!this._markerCache) {
                        this._markerCache = new Set();
                    }

                    return this._markerCache;
                },

                clearMarkerCache() {
                    if (this._markerCache) {
                        this._markerCache.clear();
                    }
                },

                getMarkerInfo(listing) {
                    return {
                        text: listing.priceText || listing.priceTypeText,
                        textSuffix: listing.pricePeriodShortText,
                        latitude: listing.address.latitude,
                        longitude: listing.address.longitude,
                        previewUrl: listing.previewUrl,
                        favoriteUrl: this.toggleFavoriteUrl(listing),
                        listing,
                    };
                },

                getClustersStyles() {
                    const clusterImgUrl = '/static/marker/cluster.svg';
                    return [{
                        textColor: 'white',
                        url: clusterImgUrl,
                        height: 45,
                        width: 45,
                    }, {
                        textColor: 'white',
                        url: clusterImgUrl,
                        height: 52,
                        width: 52,
                    }, {
                        textColor: 'white',
                        url: clusterImgUrl,
                        height: 62,
                        width: 62,
                    }, {
                        textColor: 'white',
                        url: clusterImgUrl,
                        height: 75,
                        width: 75,
                    }, {
                        textColor: 'white',
                        url: clusterImgUrl,
                        height: 90,
                        width: 90,
                    }];
                },

                setInitialMapBounds() {
                    if (this.map && this.filter.bounds && this.filter.bounds.length) {
                        this.fitMapToBounds(this.filter.bounds);
                    }
                },

                needRenderSampleImage(listing, index) {
                    const maxFullyVisibleItems = 9;
                    return listing.media && listing.media.coverPhoto && listing.media.coverPhoto.sampleHRef &&
                        index >= maxFullyVisibleItems;
                },

                centerToListing(listingId) {
                    const listing = this.getListing(listingId);

                    if (listing && this.needRenderMap && this.map) {
                        this.map.setCenter({lat: listing.address.latitude, lng: listing.address.longitude});
                    } else if (listing) {
                        this.updateFilter('lat', listing.address.latitude);
                        this.updateFilter('lon', listing.address.longitude);
                    }
                },

                increaseSearchArea() {
                    const newZoom = this.filter.zoom > this.bigCityZoom ? this.bigCityZoom : this.mapMinZoom;
                    this.updateFilter('zoom', newZoom);
                    this.$nextTick(this.applyFilter);

                    if (this.needRenderMap) {
                        this.map.setZoom(newZoom);
                        this.updateFilter('bounds', this.getCurrentBounds());
                        this.$nextTick(this.applyFilter);
                    } else {
                        this.approximatelyIncreaseBounds();
                    }
                },

                approximatelyIncreaseBounds() {
                    if (this.filter.bounds && this.filter.bounds.length) {
                        const bounds = this.filter.bounds;

                        const swLat = bounds[0];
                        const swLng = bounds[1];
                        const neLat = bounds[2];
                        const neLng = bounds[3];
                        const increaseCoef = 3; // 300%
                        const latAdjustment = (neLat - swLat) * increaseCoef;
                        const lngAdjustment = (neLng - swLng) * increaseCoef;
                        const newBounds = [swLat - latAdjustment, swLng - lngAdjustment, neLat + latAdjustment, neLng + lngAdjustment];

                        this.updateFilter('bounds', newBounds);
                        this.$nextTick(this.applyFilter);
                    }
                },

                clearFilter() {
                    const filterBase = {
                        bounds: this.filter.bounds,
                        lat: this.filter.lat,
                        lon: this.filter.lon,
                        offerType: this.filter.offerType,
                        text: this.filter.text,
                    };

                    const template = deepClone(this.filterTemplate);
                    this.filter = Object.assign(template, filterBase);

                    nextTick(() => {
                        nextTick(() => {
                            this.requestDataUpdate();
                        });
                    });
                },

                showMoreListings(listingId) {
                    this.closePreview();
                    this.centerToListing(listingId);
                    this.zoomOutMapIfTooBig();
                },

                findSimilarListings(listingId) {
                    this.closePreview();
                    this.centerToListing(listingId);
                    const bounds = this.getCurrentBounds();
                    const url = `${settings.urls.findSimilarUrl}/${listingId}`;

                    this.sendPostRequest(url, bounds).done((result) => {
                        if (result) {
                            Object.assign(this.filter, result);
                            this.zoomOutMapIfTooBig();
                        }
                    });
                },

                showListingPreview(listingId) {
                    this.preview(listingId);
                    this.centerToListing(listingId);
                },

                showOnMap(listingId, url = null) {
                    this.closePreview();
                    const googleAnalyticParameter = `src=${settings.googleAnalyticMapParameter}`;
                    if (url && url.match(googleAnalyticParameter)) {
                        const newUrl = _u.addQueryParam('src', settings.googleAnalyticMapParameter);
                        history.replaceState(window.location.state, document.title, `${newUrl}`);
                    }
                    if (this.isSmallScreen && !this.mapView) {
                        this.toggleSearchView();
                    }
                    nextTick(() => {
                        this.centerToListing(listingId);
                        this.zoomInMapIfTooSmall(this.showListingZoom);
                    });
                },

                tryShowOnMap() {
                    if (this.filter.focusListingId) {
                        this.showOnMap(this.filter.focusListingId);
                        this.filter.focusListingId = null;
                    }
                },

                sendPostRequest(url, obj) {
                    return $.ajax({
                        type: 'POST',
                        url,
                        contentType: 'application/json',
                        data: JSON.stringify(obj),
                    });
                },

                getCurrentBounds() {
                    return this.needRenderMap ? this.map.getBoundsArray() : this.filter.bounds;
                },

                getFormattedPrice(listing) {
                    return (!listing.hidePrice && listing.priceText) ? `${listing.priceText}` : listing.priceTypeText;
                },

                initPriceBounds() {
                    const isPriceOutOfMinBound = (price) => (price > 0) && (price < this.pricePickerMin);
                    const isPriceOutOfMaxBound = (price) => price > this.pricePickerMax;

                    if (isPriceOutOfMinBound(this.filter.minPrice)) {
                        this.filter.minPrice = 0;
                    }
                    if (isPriceOutOfMaxBound(this.filter.minPrice)) {
                        this.filter.minPrice = this.pricePickerMax;
                    }

                    if (isPriceOutOfMinBound(this.filter.maxPrice)) {
                        this.filter.maxPrice = this.pricePickerMin;
                    }
                    if (isPriceOutOfMaxBound(this.filter.maxPrice)) {
                        this.filter.maxPrice = null;
                    }
                },

                initAreaBounds() {
                    const isAreaNotInOptions = (area, options) => !options.map((o) => o.value).includes(area);

                    if (isAreaNotInOptions(this.filter.floorAreaMin, this.opts.areaOptions)) {
                        this.filter.floorAreaMin = null;
                    }
                    if (isAreaNotInOptions(this.filter.floorAreaMax, this.opts.areaOptions)) {
                        this.filter.floorAreaMax = null;
                    }

                    if (isAreaNotInOptions(this.filter.landAreaMin, this.opts.landAreaOptions)) {
                        this.filter.landAreaMin = null;
                    }
                    if (isAreaNotInOptions(this.filter.landAreaMax, this.opts.landAreaOptions)) {
                        this.filter.landAreaMax = null;
                    }
                },

                closeFilterOptions() {
                    this.filterOptions.isActive = false;
                },

                getDynamicFiltersMetadata(dynamicFilters, filterKeyPrefix) {
                    return dynamicFilters.map((filter) => {
                        return DynamicInputMetaFactory.createInputMeta(filter.filterControl, {
                            label: filter.displayName,
                            options: filter.validValuesList,
                            filterKey: filter.propertyName,
                            filterKeyPrefix: filterKeyPrefix,
                        });
                    });
                },

                initFilterOptions(searchOptions) {
                    let filters = {
                        address: new AddressInputMeta({label: settings.labels.addressInputPlaceholder, filterKey: 'text'}),
                        propertyType: new MultiselectInputMeta({
                            label: settings.labels.propertyType,
                            options: searchOptions.propertyTypes,
                            filterKey: 'selectedPropertyTypes',
                        }),
                        ownerType: new MultiselectInputMeta({
                            label: settings.labels.ownerType,
                            options: searchOptions.ownerTypes,
                            filterKey: 'selectedOwnerTypes',
                        }),
                        price: new RangeInputMeta({
                            label: settings.labels.price,
                            fromLabel: settings.labels.fromLabel,
                            toLabel: settings.labels.toLabel,
                            options: searchOptions.priceOptions,
                            filterKey: 'price',
                            filterMinKey: 'minPrice',
                            filterMaxKey: 'maxPrice',
                            formatter: (text) => this.$filters['formatPrice'](text, 'short'),
                        }),
                        beds: new SelectInputMeta({
                            label: settings.labels.beds,
                            options: searchOptions.bedrooms,
                            filterKey: 'selectedBedrooms',
                        }),
                        baths: new SelectInputMeta({
                            label: settings.labels.baths,
                            options: searchOptions.bathrooms,
                            filterKey: 'selectedBathrooms',
                        }),
                        floorArea: new RangeInputMeta({
                            label: settings.labels.floorArea,
                            fromLabel: settings.labels.fromLabel,
                            toLabel: settings.labels.toLabel,
                            options: searchOptions.areaOptions,
                            filterMinKey: 'floorAreaMin',
                            filterMaxKey: 'floorAreaMax',
                        }),
                        landArea: new RangeInputMeta({
                            label: settings.labels.landArea,
                            fromLabel: settings.labels.fromLabel,
                            toLabel: settings.labels.toLabel,
                            options: searchOptions.landAreaOptions,
                            filterMinKey: 'landAreaMin',
                            filterMaxKey: 'landAreaMax',
                        }),
                        matchingItem: new NoInputMeta({label: settings.labels.matchingListing, filterKey: 'matchingItemId'}),
                        aroundFeatures: new CheckGroupInputMeta({
                            label: settings.labels.aroundFeatures,
                            options: searchOptions.aroundFeatures,
                            filterKey: settings.isCommercial ? 'features.around' : 'aroundFeatures',
                        }),
                        publicationDate: new NoInputMeta({label: settings.labels.latestListings, filterKey: 'publicationDate'}),
                        viewsCount: new NoInputMeta({label: settings.labels.popularListings, filterKey: 'viewsCountRange'}),
                        pricePerArea: new TwoSidesRangeInputMeta({
                            leftSideLabel: settings.labels.budgetFriendly,
                            rightSideLabel: settings.isCommercial ? settings.labels.premium : settings.labels.elite,
                            filterKey: 'pricePerArea',
                            filterMinKey: 'pricePerArea.minimum',
                            filterMaxKey: 'pricePerArea.maximum',
                        }),
                        ecoFriendly: new CheckboxInputMeta({
                            label: settings.labels.ecoFriendly, filterKey: 'isEcoFriendly',
                        }),
                        containsVideo: new CheckboxInputMeta({
                            label: settings.labels.containsVideo, filterKey: 'containsVideo',
                        }),
                        containsPhoto: new CheckboxInputMeta({
                            label: settings.labels.containsPhoto, filterKey: 'containsPhoto',
                        }),
                    };

                    if (settings.showSolidarity) {
                        filters = {
                            solidarity: new CheckboxInputMeta({label: settings.labels.solidarityLabel, filterKey: 'solidarity'}),
                            ...filters,
                        };
                    }

                    let combinedFilters = {};

                    if (settings.isCommercial) {
                        const mainFeatures = this.getDynamicFiltersMetadata(searchOptions.mainFeatures, 'features');
                        const extendedFeatures = this.getDynamicFiltersMetadata(searchOptions.extendedFeatures, 'features');

                        combinedFilters = {
                            mainFilters: [filters.address, filters.propertyType, filters.price, filters.floorArea],
                            basicFilters: [filters.ownerType, ...mainFeatures],
                            extendedFilters: [filters.aroundFeatures, filters.landArea, ...extendedFeatures],
                            hiddenFilters: [],
                            isActive: false,
                        };
                    } else {
                        const indoorFeatures = new CheckGroupInputMeta({
                            label: settings.labels.indoorFeatures,
                            options: searchOptions.indoorFeatures,
                            filterKey: 'indoorPropertyFeatures',
                        });
                        const outdoorFeatures = new CheckGroupInputMeta({
                            label: settings.labels.outdoorFeatures,
                            options: searchOptions.outdoorFeatures,
                            filterKey: 'outdoorPropertyFeatures',
                        });
                        const environmentalFeatures = new CheckGroupInputMeta({
                            label: settings.labels.environmentalFriendliness,
                            options: searchOptions.environmentalFeatures,
                            filterKey: 'environmentalFriendliness',
                        });
                        const areaPerRoom = new TwoSidesRangeInputMeta({
                            leftSideLabel: settings.labels.small,
                            rightSideLabel: settings.labels.spacious,
                            filterKey: 'areaPerRoom',
                            filterMinKey: 'areaPerRoom.minimum',
                            filterMaxKey: 'areaPerRoom.maximum',
                        });
                        const buildingFeatures = this.getDynamicFiltersMetadata(searchOptions.buildingFeatures, 'buildingFeatures');
                        const specificFeatures = new SelectInputMeta({
                            options: searchOptions.specificFeatures,
                            filterKey: 'specificFeatures',
                            hasPrefix: false,
                        });

                        combinedFilters = {
                            mainFilters: [filters.address, filters.propertyType, filters.price, filters.beds],
                            basicFilters: [filters.baths, filters.floorArea, filters.landArea, filters.ownerType],
                            extendedFilters: [indoorFeatures, outdoorFeatures, filters.aroundFeatures, environmentalFeatures,
                                ...buildingFeatures],
                            hiddenFilters: [areaPerRoom, specificFeatures],
                            isActive: false,
                        };

                        if (settings.isRent && settings.showSolidarity) {
                            combinedFilters.extendedFilters.push(filters.solidarity);
                        }
                    }

                    if (settings.matchingItemId) {
                        combinedFilters.extendedFilters.push(filters.matchingItem);
                    }

                    combinedFilters.hiddenFilters = [...combinedFilters.hiddenFilters, filters.publicationDate, filters.viewsCount,
                        filters.pricePerArea, filters.ecoFriendly, filters.containsVideo, filters.containsPhoto,
                    ];

                    return combinedFilters;
                },

                extractCityNameFromSearchResult(searchResult) {
                    let city;

                    if (searchResult.filter.previewId && settings.searchResult.results.length) {
                        city = settings.searchResult.results[0].address.city;
                    }

                    if (!city) {
                        city = this.extractCityFromAddress(searchResult.filter.text);
                    }

                    return city;
                },

                extractCityFromAddress(address) {
                    if (!address) {
                        return address;
                    }

                    try {
                        const matches = address.match(/([^(,\d)]+)/g).filter((m) => {
                            const match = m.trim();
                            return match !== '' && match !== '-';
                        });
                        if (matches.length > 1) {
                            return matches[matches.length - 1].trim();
                        }
                    } catch (ex) {
                        console.log(`failed to extract city from address${address}\n${ex}`);
                    }

                    return address;
                },

                openReportModal(listingId, reportType, listingType) {
                    globalActions.openReportModal({targetId: listingId, reportType, listingType});
                },

                raiseRelevance(raiseRelevanceUrl, orderUrl) {
                    $.post(raiseRelevanceUrl)
                        .then(() => {
                            this.showUpdatedModal = true;
                            this.createOrderUrl = orderUrl;
                        })
                        .fail(globalActions.handleAjaxErrors);
                },

                subscribeOpenModals() {
                    store.subscribe((mutation) => {
                        if (mutation.type === 'openBoostModal') {
                            this.showBoostModal = true;
                        }
                    });
                },

                // override method from openPreviewMixin
                subscribeOpenPreview() {
                    store.subscribe((mutation) => {
                        if (mutation.type === 'openPreview') {
                            this.searchPreviewUrl = mutation.payload.previewUrl;
                            if (mutation.payload.listingType !== this.opts.listingType || store.state.shared.chatOpened) {
                                this._openPreview(mutation.payload.previewUrl);
                            } else {
                                this.preview(mutation.payload.listingId);
                            }
                        }
                    });
                },

                _autocompleteCallback(result) {
                    const addressInputMeta = this.filterOptions.mainFilters.find((opt) => opt instanceof AddressInputMeta);

                    if (result) {
                        this.titleAddress = this._extractTitleAddressFromGeoData(result);
                        this.isNewDataSearched = true;
                        this.updatePageTitle();

                        this.updateFilter('text', result.formatted);
                        this.updateFilter('lat', result.latitude);
                        this.updateFilter('lon', result.longitude);
                        this.updateFilter('bounds', result.bounds);
                        this.cityName = result.city || this.extractCityFromAddress(result.formatted);
                        addressInputMeta.error = null;
                        this.repositionMap();
                    } else {
                        addressInputMeta.error = this.labels.addressInputUnrecognized;
                    }
                },

                _initAutocomplete() {
                    store.subscribe((mutation) => {
                        if (mutation.type === 'autocompleteCallback') {
                            this._autocompleteCallback(mutation.payload);
                        }
                    });
                },

                isShowRelevanceModalNeeded() {
                    return window.location.href.includes('showRelevanceModal=True');
                },

                showRelevanceModal() {
                    this.showUpdatedModal = true;
                },

                _extractTitleAddressFromGeoData(geoData) {
                    try {
                        const gMapData = JSON.parse(geoData.jsonSerializedGMapData);

                        if (!gMapData) {
                            return geoData.formatted;
                        }

                        const geoDataResult = gMapData.result ?? gMapData.results[0];

                        let titleAddress = geoDataResult.address_components
                            .filter((x) => x.types.includes('route') || x.types.includes('locality'))
                            .map((x) => x.short_name)
                            .join(', ');

                        if (!titleAddress) {
                            titleAddress = geoDataResult.formatted_address;
                        }

                        return titleAddress;
                    } catch {
                        return this.searchText;
                    }
                },
            },

            mounted() {
                this._initAutocomplete();
                this.subscribeOpenModals();
                nextTick(() => this.setInitialMapBounds());

                if (this.isShowRelevanceModalNeeded()) {
                    this.showRelevanceModal();
                }

                this.initPageTitle();
            },

            created() {
                this.initPriceBounds();
                this.initAreaBounds();
            },
        });

        initListingCardComponent(app);
        initCustomControls(app);
        initSearchFilterComponent(app);
        initMapMakerComponent(app);
        initCustomInputsComponents(app);
        initFavoriteSwitchComponent(app);
        initCurrencyPriceComponents(app);
        initListingExtraDetailsComponent(app);
        initListingContactForm(app);
        initGAComponents(app);
        initAutocompleteComponent(app);
        initCommentsComponents(app);
        initGaTrackerComponent(app);
        initSocialsComponent(app);
        initListReviewComponents(app);
        initPriceHistoryChartComponent(app);
        initListingStatisticsComponent(app);
        initStarRatingComponent(app);
        initMortgageCalculator(app);
        initMarkdownViewerComponent(app);
        initOpenHoursComponent(app);
        initAdvertPreviewComponent(app);
        initCreateOneClickInquiry(app);

        app.mount(settings.el);

        return app;
    });
};

export {initSearchPage};
